import { Routes, Route, Navigate } from "react-router-dom";

// Material Dashboard 2 React routes
import routes from "./routes";
import MasterLayout from "../../Layouts/MasterLayout";
import TopbarLayout from "../../Layouts/TopbarLayout";

export default function Integration() {
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.items && route.items.length) {
        return getRoutes(route.items);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <TopbarLayout routes={routes.filter((route) => route.title)}>
      <Routes>
        {getRoutes(routes)}
        {/* <Route path="*" element={<Navigate to="/app/dashboard" />} /> */}
      </Routes>
    </TopbarLayout>
  );
}
